import { Switch } from 'react-router-dom'
import Layout from '../components/layout/Layout'
//import { AtendimentoProvider } from '../contexts/AtendimentoContext'
import Login from '../pages/login/Login'
import PrivateRoutes from './privateRoutes'





import NotFound from '../pages/login/NotFound'

import Ponto from '../pages/Ponto'
import { Home } from '../pages/Home'
import ConsultarSimple from '../pages/atendimento/ConsultarSimple'
import ClientesListar from '../pages/clientes/listar'
import ColaboradoresListar from '../pages/colaboradores/listar'
import ContratosListar from '../pages/contratos/listar'
import DespesasListar from '../pages/despesas/listar'
import EntradasListar from '../pages/entradas/listar'
import SaidasListar from '../pages/saidas/listar'
import TiposPagamentosListar from '../pages/tiposPagamentos/listar'
import EntradasRelatorio from '../pages/entradas/relatorio'
import ContaListar from '../pages/conta/listar'
import { useAuth } from '../hooks/Auth'
import SaidasRelatorio from '../pages/saidas/relatorio'

export default function Routes({ ...rest }) {
  const { user } = useAuth();


    return (
      <>
        <Switch>
          <PrivateRoutes exact path="/" component={Login}/>

          {/* <PrivateRoutes
            path="/recuperar-senha"
            component={RecuperarSenha}
          />
          
          <PrivateRoutes
            path="/recuperar-senha/:token"
            component={RecuperarSenha}
          /> */}

          {!!user ? (

            <Layout>

              <PrivateRoutes
                exact
                path="/home"
                component={Home}
                isPrivate
              />

              <PrivateRoutes
                exact
                path="/clientes"
                component={ClientesListar}
                isPrivate
                />

              <PrivateRoutes
                exact
                path="/colaboradores"
                component={ColaboradoresListar}
                isPrivate
                />

              <PrivateRoutes
                exact
                path="/contratos"
                component={ContratosListar}
                isPrivate
                />

              <PrivateRoutes
                exact
                path="/despesas"
                component={DespesasListar}
                isPrivate
                />
              <PrivateRoutes
                exact
                path="/entradas"
                component={EntradasListar}
                isPrivate
                />

              <PrivateRoutes
                exact
                path="/entradas/relatorio"
                component={EntradasRelatorio}
                isPrivate
                />

              <PrivateRoutes
                exact
                path="/saidas/relatorio"
                component={SaidasRelatorio}
                isPrivate
                />
              
              <PrivateRoutes
                exact
                path="/saidas"
                component={SaidasListar}
                isPrivate
                />
                <PrivateRoutes
                exact
                path="/tipo-pagamento"
                component={TiposPagamentosListar}
                isPrivate
                /> 

              <PrivateRoutes
                exact
                path="/contas"
                component={ContaListar}
                isPrivate
                /> 
            </Layout>

            ) : (
              <PrivateRoutes path="*" component={NotFound} />
            )}

        </Switch>
      </>
    );
}
